import { FormEvent } from 'react';
import { FormGroup, Button, FormControl, ControlLabel } from 'react-bootstrap';
import { INewContact } from '@nkr/models/index';
import { INewContactValidation } from './new-contact-validation';

interface IProps {
    data: INewContact,
    validation: INewContactValidation,
    onDataChange: (value: string, property: string) => void,
    onCancel: () => void
}

const NewContact = (props: IProps) => {
    const handleFirstNameChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        props.onDataChange(e.currentTarget.value, 'firstName');
    };

    const handleLastNameChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        props.onDataChange(e.currentTarget.value, 'lastName');
    };

    const handleEmailChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        props.onDataChange(e.currentTarget.value, 'email');
    };

    const handlePhoneNumberChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        props.onDataChange(e.currentTarget.value, 'phoneNumber');
    };

    return (
        <FormGroup>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <ControlLabel style={{ marginRight: 15 }}>Add New Contact</ControlLabel>
                <div style={{ marginBottom: 5 }}><Button bsStyle="link" style={{ padding: 0 }} onClick={props.onCancel}>Cancel</Button></div>
            </div>
            <div style={{ paddingLeft: 20, paddingBottom: 20, borderLeft: '1px dotted #ccc' }}>
                <FormGroup validationState={!props.validation.firstName ? 'error' : null}>
                    <ControlLabel>First Name</ControlLabel>
                    <FormControl
                        value={props.data.firstName}
                        onChange={handleFirstNameChange}
                    />
                </FormGroup>

                <FormGroup validationState={!props.validation.lastName ? 'error' : null}>
                    <ControlLabel>Last Name</ControlLabel>
                    <FormControl
                        value={props.data.lastName}
                        onChange={handleLastNameChange}
                    />
                </FormGroup>

                <FormGroup validationState={!props.validation.email ? 'error' : null}>
                    <ControlLabel>Email</ControlLabel>
                    <FormControl
                        value={props.data.email}
                        onChange={handleEmailChange}
                    />
                </FormGroup>

                <FormGroup validationState={!props.validation.phoneNumber ? 'error' : null}>
                    <ControlLabel>Phone Number</ControlLabel>
                    <FormControl
                        value={props.data.phoneNumber}
                        onChange={handlePhoneNumberChange}
                    />
                </FormGroup>
            </div>
        </FormGroup>
    );
}

export default NewContact;